import { render, staticRenderFns } from "./NvHistoryItem.vue?vue&type=template&id=73bb5ac2&scoped=true&"
import script from "./NvHistoryItem.vue?vue&type=script&lang=js&"
export * from "./NvHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./NvHistoryItem.vue?vue&type=style&index=0&id=73bb5ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb5ac2",
  null
  
)

export default component.exports